import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import { retrieveUsers, retrieveOneUser, retrieveOneUserByUuid, setSelectedUser } from "../slices/userSlice";

import { debugLog, errorLog } from "../utils/debugUtils";

// Custom hook for users module async actions (fetching list, fetching single user, etc.)
export const useUsersData = () => {
	const dispatch = useDispatch();

	const fetchUsers = useCallback(() => {
		debugLog(3, "[useUsersData][ACTION] fetchUsers", {});
		debugLog(2, "[useUsersData][FLOW] retrieveUsers started", {});
		trackPromise(
			dispatch(retrieveUsers())
				.unwrap()
				.then((response) => {
					debugLog(3, "[useUsersData][STATE] fetchUsers success", {
						count: response?.length ?? 0,
					});
				})
				.catch((err) => {
					errorLog(2, "[useUsersData][FLOW] retrieveUsers failed", { error: err });
					console.error("Failed to fetch users", err);
				})
		);
	}, [dispatch]);

	const fetchUserByIdOrUuid = useCallback(
		(idOrUuid) => {
			debugLog(3, "[useUsersData][ACTION] fetchUserByIdOrUuid", { idOrUuid: idOrUuid });
			const action = isNaN(idOrUuid) ? retrieveOneUserByUuid(idOrUuid) : retrieveOneUser(idOrUuid);
			debugLog(2, "[useUsersData][FLOW] retrieveOneUser started", { idOrUuid: idOrUuid });

			trackPromise(
				dispatch(action)
					.unwrap()
					.then((response) => {
						debugLog(3, "[useUsersData][STATE] fetchUserByIdOrUuid success", {
							id: response?.id,
							uuid: response?.uuid,
						});

						dispatch(setSelectedUser(response));
					})
					.catch((err) => {
						errorLog(2, "[useUsersData][FLOW] retrieveOneUser failed", {
							idOrUuid: idOrUuid,
							error: err,
						});
						console.error("Failed to fetch user", err);
					})
			);
		},
		[dispatch]
	);

	return {
		fetchUsers,
		fetchUserByIdOrUuid,
	};
};
